import { render, staticRenderFns } from "./DarkmodeToggler.vue?vue&type=template&id=36a8d54c&scoped=true&"
import script from "./DarkmodeToggler.vue?vue&type=script&lang=js&"
export * from "./DarkmodeToggler.vue?vue&type=script&lang=js&"
import style0 from "./DarkmodeToggler.vue?vue&type=style&index=0&id=36a8d54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a8d54c",
  null
  
)

export default component.exports